import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Popin} from '../models/popin.model';
import {Product} from '../models/product.model';
import {environment} from '../../environments/environment';

@Injectable()
export class PopinService {

  public url: string;
  constructor(private httpClient: HttpClient) {
    this.url = environment.backend;
  }

  getPopin(host) {
    return new Promise ((resolve, reject) => {
      this.httpClient
        .get<Popin>(this.url + '/popin/host/' + host)
        .subscribe(
          (popin) => {
            resolve(popin);
          },
          (error) => {
            reject(error);
          }
        );
    });
  }

  getAccountInfos(account) {
    return new Promise ((resolve, reject) => {
      this.httpClient
        .get(this.url + '/account/' + account + '/companyaccount')
        .subscribe(
          (response) => {
            resolve(response);
          },
          (error) => {
            reject(error);
          }
        );
    });
  }

  getAccountProducts(account) {
    return new Promise ((resolve, reject) => {
      this.httpClient
        .get<Product[]>(this.url + '/account/' + account + '/products')
        .subscribe(
          (products) => {
            resolve(products);
          },
          (error) => {
            reject(error);
          }
        );
    });
  }

  getProductById(productClients) {
    return new Promise ((resolve, reject) => {
      this.httpClient
        .post<Product[]>(this.url + '/product/idlist', productClients)
        .subscribe(
          (products) => {
            resolve(products);
          },
          (error) => {
            reject(error);
          }
        );
    });
  }

  isCustomer(companyIdentifier, popinId) {
    return new Promise ((resolve, reject) => {
      this.httpClient
        .get(this.url + '/product/iscustomer/' + popinId + '/' + companyIdentifier)
        .subscribe(
          response => {
            resolve(response);
          },
          (error) => {
            reject(error);
          }
        );
    });
  }

  getCoefficyInformations(companyIdentifier) {
    return new Promise ((resolve, reject) => {
      this.httpClient
        .post(this.url + '/coefficy/api/company/' + companyIdentifier, [])
        .subscribe(
          response => {
            resolve(response);
          },
          (error) => {
            reject(error);
          }
        );
    });
  }

}
